import { Routes } from '@angular/router';
import { AUTH_M_ROUTES } from './shared/auth-m/auth-m.routes';

/**
 * Routing now runs on the new Auth-M auth (see shared/auth-m). The old
 * maw-auth `check-portal` + `maw-template` admin routes were removed from the
 * router (their components remain on disk); admins land on the Auth-M admin
 * dashboard instead. The CMS home/front-end is unchanged.
 */
export const routes: Routes = [
    // Auth-M portals (admin / invited / consumer) — listed first so /admin,
    // /invited and /end-users resolve here. Single-segment CMS slugs still fall
    // through to the front-end route below.
    ...AUTH_M_ROUTES,

    // Immunopedia v2 prototype, full page (own header, no PathPedia chrome).
    // Listed before '' so it wins over the front-end /pages layout.
    {
        path: 'pages/immonopedia-v2',
        loadChildren: () => import('./components/front-end/immonopedia-v2/immunopedia-v2.routes').then(m => m.IMMUNOPEDIA_V2_ROUTES)
    },

    // CMS home + public site (unchanged).
    {
        path: '',
        loadChildren: () => import('./components/front-end/front-end.routes').then(m => m.FrontEndRoutes)
    },
    { path: '**', redirectTo: '' }
];
